import { render, staticRenderFns } from "./SettingsTabShipmentTypes.vue?vue&type=template&id=f07081c6&scoped=true"
import script from "./SettingsTabShipmentTypes.vue?vue&type=script&lang=ts"
export * from "./SettingsTabShipmentTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07081c6",
  null
  
)

export default component.exports